export default __webpack_public_path__ + "static/media/Corp-time.b740cefa.svg";